export const FETCH_COPY_DOCUMENTS_REQUEST = 'FETCH_COPY_DOCUMENTS_REQUEST'
export const FETCH_COPY_DOCUMENTS_SUCCESS = 'FETCH_COPY_DOCUMENTS_SUCCESS'
export const FETCH_COPY_DOCUMENTS_FALUIRE = 'FETCH_COPY_DOCUMENTS_FALUIRE'
